import { Dispatch, Fragment, SetStateAction } from "react"
import { DisplayResultsBy, TestResultForm, WaterlineTestResult } from "../../types"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import { DatePicker } from "@mui/x-date-pickers/DatePicker"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import dayjs, { Dayjs } from "dayjs"

type TestDateField = {
  testResult: WaterlineTestResult | null,
  displayBy: DisplayResultsBy,
  formData: TestResultForm,
  setFormData: Dispatch<SetStateAction<TestResultForm>>,
}

const TestDateField = (props: TestDateField) => {
  const { testResult, displayBy, formData, setFormData } = props

  const handleChange = (value: Dayjs | null) => {
    const nextForm = structuredClone(formData)

    const testDate = value?.isValid()
      ? value.toISOString() 
      : null

    nextForm.test_date = testDate

    setFormData(nextForm)
  }

  const label = 'Test Date *'
  const value = formData.test_date ? dayjs(formData.test_date) : null

  return (
    <Fragment>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en">
        <DatePicker
          disabled={Boolean(testResult) && displayBy === 'testDate'}
          label={label}
          defaultValue={dayjs(new Date())}
          slotProps={{ textField: { size: 'small' } }}
          value={value}
          onChange={selectedDate => handleChange(selectedDate)}
          format="MM-DD-YYYY"
        />
      </LocalizationProvider>
    </Fragment>
  )
}

export default TestDateField
